/**
 * Default offline/seed site data for ADMALL INDIA.
 * Ensures the website always renders completely and beautifully (0ms first paint)
 * even before the backend API responds, or when running statically.
 */

export const MEDIA = {
  hero_bg: "https://static.prod-images.emergentagent.com/jobs/c6f51fbc-ba88-4cac-a357-6a477f785856/images/052fd9c777a93a24a010dc9244775e2bc0920accf6c6276bbdeb3496743a3235.jpeg",
  storytelling_film: "https://static.prod-images.emergentagent.com/jobs/c6f51fbc-ba88-4cac-a357-6a477f785856/images/2d69758685be1507adfa52dc83be500f77a6e7a635f1523356c64b1336ead048.jpeg",
  legacy_collage: "https://static.prod-images.emergentagent.com/jobs/c6f51fbc-ba88-4cac-a357-6a477f785856/images/8c891b51d9c60783e4860786c1caa482becd286bbd39ab0daac30b0abfb9c552.jpeg",
  positioning_bg: "https://static.prod-images.emergentagent.com/jobs/c6f51fbc-ba88-4cac-a357-6a477f785856/images/b616d5206c8582c14f25ce9546989584b747f8739f34f1c9709405a9336a1531.jpeg",
  crew1: "https://images.pexels.com/photos/8088379/pexels-photo-8088379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  crew2: "https://images.unsplash.com/photo-1781127445273-0f1fdca3a9f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  crew3: "https://images.unsplash.com/photo-1781127445118-8140677fdea1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  crew4: "https://images.unsplash.com/photo-1781127445209-f02336fa36a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  analytics: "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  product: "https://images.unsplash.com/photo-1728464864608-98006d66f075?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  real_estate: "https://images.unsplash.com/photo-1723110994499-df46435aa4b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  manufacturing: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  healthcare: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  education: "https://images.pexels.com/photos/30052431/pexels-photo-30052431.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  hospitality: "https://images.unsplash.com/photo-1758714919725-d2740fc99f14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  entertainment: "https://images.unsplash.com/photo-1619229724167-220710df9ac2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  founder: "https://images.unsplash.com/photo-1584940120505-117038d90b05?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const DEFAULT_CONTENT = {
  key: "singleton",
  logo_url: "/admall-logo.png",
  settings: {
    phone: "+91 93221 06632",
    phone_raw: "+919322106632",
    whatsapp: "https://wa.me/919322106632",
    email: "admallindiagroup@gmail.com",
    location: "Navi Mumbai, Maharashtra, India",
    website: "admallindia.com",
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
  },
  hero: {
    eyebrow: "INTEGRATED ADVERTISING • MULTIMEDIA PRODUCTION • DIGITAL MARKETING",
    headline_lines: [
      { text: "BUILD THE BRAND.", style: "white" },
      { text: "CREATE THE ", style: "outline" },
      { text: "ATTENTION.", style: "outline" },
      { text: "DRIVE THE GROWTH.", style: "orange" },
    ],
    subheading: "FROM IDEA TO IMPACT.",
    support_text: "We connect strategy, branding, content, multimedia production and performance marketing under one accountable partner.",
    cta_primary: { label: "START A PROJECT", url: "#contact" },
    cta_secondary: { label: "EXPLORE SERVICES", url: "#services" },
    cta_showreel: { label: "WATCH OUR SHOWREEL", url: "" },
    bg_image: MEDIA.hero_bg,
    poster_image: MEDIA.hero_bg,
    mobile_image: MEDIA.hero_bg,
    video_url: "/api/files/admallindia/uploads/a1035118-e752-45fc-8eda-c29278f9ce66.mp4",
    stats: [
      { value: "20+", label: "YEARS OF EXPERIENCE" },
    ],
  },
  marquee: {
    words: [
      { text: "CREATE", style: "solid" },
      { text: "GROWTH", style: "outline" },
      { text: "THINK", style: "solid" },
      { text: "CREATE", style: "outline" },
      { text: "GROWTH", style: "solid" },
      { text: "THINK", style: "outline" },
    ],
  },
  problem: {
    heading_lines: ["MARKETING SHOULDN'T BE", "A COLLECTION OF VENDORS."],
    points: [
      "Your brand may need a new identity.",
      "Your business may need better content.",
      "Your sales team may need more enquiries.",
      "Your digital presence may need fixing.",
      "Your advertising may need better performance.",
    ],
    conclusion: "ADMALL INDIA BRINGS THEM TOGETHER.",
    sub: "Brand strategy, creative development, multimedia production, digital marketing, advertising and lead generation into one connected marketing system.",
  },
  positioning: {
    small: "ADMALL INDIA IS NOT ANOTHER DIGITAL MARKETING VENDOR.",
    big: "ADMALL INDIA IS THE INTEGRATED CREATIVE + MARKETING PARTNER BETWEEN YOUR BUSINESS AND YOUR CUSTOMER.",
    bg_image: MEDIA.positioning_bg,
  },
  journey: {
    heading: "THE ADMALL METHOD",
    steps: [
      { num: "01", title: "THINK", desc: "Understand the business, its customers, positioning, and commercial reality.", image: MEDIA.crew2 },
      { num: "02", title: "CREATE", desc: "Build the visual brand identity, storytelling assets, and high-impact media.", image: MEDIA.storytelling_film },
      { num: "03", title: "REACH", desc: "Connect with target audiences across targeted search, social, and digital channels.", image: MEDIA.crew3 },
      { num: "04", title: "CONVERT", desc: "Generate meaningful business enquiries and measurable high-intent actions.", image: MEDIA.analytics },
      { num: "05", title: "GROW", desc: "Measure performance data, optimize continuous conversion, and scale with conviction.", image: MEDIA.crew1 },
    ],
  },
  experience: {
    number: "20+",
    title: "YEARS OF EXPERIENCE",
    sub: "Digital • Advertising • Multimedia",
    images: [MEDIA.legacy_collage, MEDIA.crew4, MEDIA.crew1, MEDIA.analytics],
  },
  build: {
    heading: "WHAT WE CAN BUILD FOR YOU",
    items: [
      { title: "BRAND", desc: "Create an identity people can recognise, understand and remember.", image: MEDIA.crew2 },
      { title: "CONTENT", desc: "Develop visual and audio-visual communication designed around your brand and audience.", image: MEDIA.storytelling_film },
      { title: "ADVERTISING", desc: "Put the right message in front of the right audience across relevant channels.", image: MEDIA.crew3 },
      { title: "LEADS", desc: "Build campaigns and conversion journeys designed to generate meaningful business enquiries.", image: MEDIA.analytics },
      { title: "DIGITAL PRESENCE", desc: "Improve visibility across search, social platforms, websites and local discovery.", image: MEDIA.product },
      { title: "GROWTH", desc: "Measure what matters, learn from the data and continuously improve.", image: MEDIA.crew1 },
    ],
  },
  system: {
    heading_lines: ["NOT JUST", "MORE MARKETING.", "BETTER CONNECTED MARKETING."],
    points: [
      { k: "Brand", v: "gives people a reason to remember you." },
      { k: "Content", v: "gives them something worth noticing." },
      { k: "Advertising", v: "gives you distribution." },
      { k: "Performance marketing", v: "gives you measurable action." },
      { k: "Analytics", v: "tells you what to improve." },
    ],
    conclusion: "ADMALL connects the system.",
  },
  storytelling: {
    heading: "WE DON'T DESCRIBE IT. WE PRODUCE IT.",
    quote: "AI provides speed. Experience provides judgement.",
    images: [MEDIA.storytelling_film, MEDIA.crew3, MEDIA.product, MEDIA.crew4],
  },
  founder: {
    heading_lines: ["THE PERSON", "BEHIND THE", "PARTNERSHIP."],
    name: "PARESH TRIVEDI",
    role: "Founder & Strategic Partner",
    bio: "Present as a strategic creative leader with almost two decades of digital and multimedia experience — someone who builds brands, not just campaigns.",
    image: "/api/files/admallindia/uploads/5a38bc5b-89b8-473e-87c3-285b3972153e.webp",
    responsibilities: [
      "Strategic direction",
      "Creative thinking",
      "Key client relationships",
      "Brand development",
      "Quality standards",
      "Strategic partnerships",
      "Major campaign decisions",
      "Business development",
    ],
    approach: [
      "Listen first.",
      "Understand the business.",
      "Challenge the obvious answer.",
      "Create what makes sense.",
      "Measure what matters.",
    ],
  },
  why: {
    heading: "WHY ADMALL",
    points: [
      "ONE ACCOUNTABLE PARTNER",
      "CROSS-DISCIPLINE EXPERIENCE",
      "SENIOR INVOLVEMENT",
      "FLEXIBLE DELIVERY",
      "PRACTICAL USE OF AI",
      "TRANSPARENT MARKETING",
    ],
    statement_lines: ["AGENCIES OFTEN SELL SERVICES.", "ADMALL SELLS CONNECTED THINKING + EXECUTION."],
  },
  not_promise: {
    heading: "WHAT WE DO NOT PROMISE",
    nots: ["Instant virality.", "Guaranteed sales.", "Magic algorithms.", "Thousands of meaningless followers."],
    promise_title: "WE PROMISE A BETTER PROCESS.",
    promises: ["Clear strategy.", "Strong creative.", "Disciplined execution.", "Transparent measurement.", "Continuous improvement."],
  },
  process: {
    heading: "HOW WE WORK",
    steps: [
      { num: "01", title: "YOU TELL US THE PROBLEM.", desc: "What are you trying to achieve?" },
      { num: "02", title: "WE UNDERSTAND THE BUSINESS.", desc: "Market, customer, offer and competition." },
      { num: "03", title: "WE IDENTIFY THE OPPORTUNITY.", desc: "Where can branding, content or marketing make the biggest difference?" },
      { num: "04", title: "WE PROPOSE THE RIGHT MODEL.", desc: "Project, retainer or growth partnership." },
      { num: "05", title: "WE EXECUTE & MEASURE.", desc: "Create. Launch. Track. Learn. Improve." },
    ],
  },
  growth_check: {
    heading: "YOUR FIRST STEP IS FREE.",
    copy: "Tell us what you are trying to achieve. We will understand your business, identify the most obvious marketing opportunities and explain where ADMALL can add value.",
    cta: "GET MY FREE GROWTH CHECK",
    note: "No obligation. No generic sales presentation.",
  },
  contact: {
    heading_lines: ["LET'S FIND OUT", "WHAT YOUR BUSINESS", "ACTUALLY NEEDS."],
    copy: "You do not need to know which service to buy. Tell us what you are trying to achieve. We will help identify the appropriate starting point.",
    cta: "REQUEST A FREE GROWTH CONSULTATION",
  },
  footer: {
    tagline: "THINK. CREATE. REACH. PERFORM. GROW.",
    disciplines: "Brand Strategy | Creative | Multimedia | Digital Marketing | Advertising | Lead Generation | AI Marketing",
  },
  clients: {
    heading: "SERVING BUSINESSES ACROSS INDIA & BEYOND",
    sub: "India • Metro • Tier-2 • Tier-3 • International Clients",
  },
};

export const DEFAULT_SERVICES = [
  {
    order: 1,
    code: "SERVICE 01",
    title: "BRAND ENGINEERING",
    tagline: "Build the foundation before buying attention.",
    image: MEDIA.crew2,
    enabled: true,
    bullets: [
      "Brand strategy", "Brand naming", "Positioning", "USP development",
      "Brand architecture", "Logo & visual identity", "Brand messaging",
      "Corporate identity", "Brand guidelines", "Presentation & pitch design",
      "Campaign concepts", "AI-assisted brand intelligence"
    ]
  },
  {
    order: 2,
    code: "SERVICE 02",
    title: "MULTIMEDIA PRODUCTION",
    tagline: "Turn ideas into communication people can see, hear and remember.",
    image: MEDIA.storytelling_film,
    enabled: true,
    bullets: [
      "Brand films", "Corporate films", "Advertisement films", "Product videos",
      "Promotional films", "Reels & short-form video", "Interviews & testimonials",
      "Event films", "Product photography", "Image engineering", "Motion graphics",
      "Explainer videos", "AI-assisted visual production"
    ]
  },
  {
    order: 3,
    code: "SERVICE 03",
    title: "DIGITAL MARKETING",
    tagline: "Build visibility where your customers actually search and spend attention.",
    image: MEDIA.analytics,
    enabled: true,
    bullets: [
      "Social Media Marketing", "SEO", "Google Search", "YouTube", "Meta Advertising",
      "LinkedIn Marketing", "Content Marketing", "Google Business Profile optimisation",
      "Local search visibility", "Remarketing", "Landing-page strategy", "Conversion optimisation"
    ]
  },
  {
    order: 4,
    code: "SERVICE 04",
    title: "PERFORMANCE & LEAD GENERATION",
    tagline: "ATTENTION IS NOT THE FINISH LINE.",
    image: MEDIA.product,
    enabled: true,
    bullets: [
      "Lead-generation campaigns", "Google Ads", "Meta Ads", "Campaign creative",
      "Audience strategy", "Landing-page recommendations", "Lead qualification",
      "Conversion tracking", "Remarketing", "Campaign optimisation", "Performance reporting"
    ]
  },
  {
    order: 5,
    code: "SERVICE 05",
    title: "AI-POWERED MARKETING",
    tagline: "AI IS NOT OUR PROPOSITION. IT IS ONE OF OUR TOOLS.",
    image: MEDIA.crew4,
    enabled: true,
    bullets: [
      "Research", "Brand ideation", "Content development", "Creative variations",
      "Image enhancement", "Video concepts", "Content repurposing", "Marketing workflows",
      "Campaign analysis", "Automation"
    ]
  }
];

export const DEFAULT_INDUSTRIES = [
  {
    order: 1,
    title: "REAL ESTATE",
    desc: "Project branding, property films, digital campaigns, lead generation, location marketing and sales communication.",
    image: MEDIA.real_estate,
    enabled: true
  },
  {
    order: 2,
    title: "MANUFACTURING & B2B",
    desc: "Corporate identity, product communication, digital visibility, LinkedIn, search marketing, enquiry generation and sales-support content.",
    image: MEDIA.manufacturing,
    enabled: true
  },
  {
    order: 3,
    title: "D2C",
    desc: "Brand positioning, product content, social media, performance advertising, creative testing and customer acquisition.",
    image: MEDIA.product,
    enabled: true
  },
  {
    order: 4,
    title: "HEALTHCARE",
    desc: "Professional brand communication, local visibility, informative content and appropriately managed digital campaigns.",
    image: MEDIA.healthcare,
    enabled: true
  },
  {
    order: 5,
    title: "EDUCATION",
    desc: "Institutional branding, admission campaigns, content production, local visibility and enquiry generation.",
    image: MEDIA.education,
    enabled: true
  },
  {
    order: 6,
    title: "HOSPITALITY",
    desc: "Brand storytelling, photography, video, social media, local discovery, promotions and booking-oriented campaigns.",
    image: MEDIA.hospitality,
    enabled: true
  },
  {
    order: 7,
    title: "ENTERTAINMENT",
    desc: "Artist branding, event campaigns, promotional films, digital audience development and social content.",
    image: MEDIA.entertainment,
    enabled: true
  }
];

export const DEFAULT_SOLUTIONS = [
  { order: 1, code: "01", title: "BRAND STARTER", hook: "BUILD THE FOUNDATION.", desc: "For businesses needing a stronger identity.", price: "Starting from ₹35,000", note: "", features: [], enabled: true },
  { order: 2, code: "02", title: "CONTENT ENGINE", hook: "NEVER RUN OUT OF REASONS TO BE SEEN.", desc: "Consistent content designed around your brand and audience.", price: "Starting from ₹25,000/month", note: "", features: [], enabled: true },
  { order: 3, code: "03", title: "LEAD ENGINE", hook: "TURN ATTENTION INTO ENQUIRIES.", desc: "Campaigns and journeys built to generate business enquiries.", price: "Starting from ₹35,000/month", note: "Advertising media spend is separate.", features: [], enabled: true },
  { order: 4, code: "04", title: "GROWTH PARTNER", hook: "YOUR MARKETING TEAM, WITHOUT BUILDING ONE FROM SCRATCH.", desc: "Custom engagement combining Brand, Content, Production, Digital, Advertising, Lead Generation and Analytics.", price: "Custom engagement", note: "", features: [], enabled: true },
  { order: 5, code: "05", title: "90-DAY GROWTH SPRINT", hook: "THREE MONTHS. ONE CLEAR OBJECTIVE.", desc: "Month 1 — Foundation: strategy, positioning, creative direction, tracking, campaign architecture. Month 2 — Activation: content, advertising, lead generation, audience testing. Month 3 — Optimisation: analyse, improve, strengthen conversion.", price: "Starting from ₹1,00,000", note: "Media budget and production costs are scoped separately where applicable.", features: [], enabled: true }
];

export const DEFAULT_EVENTS = [];

export const DEFAULT_SITE_DATA = {
  content: DEFAULT_CONTENT,
  services: DEFAULT_SERVICES,
  industries: DEFAULT_INDUSTRIES,
  solutions: DEFAULT_SOLUTIONS,
  case_studies: [],
  events: DEFAULT_EVENTS,
};
